<template>
  <div>
  <v-row>
    <v-col cols="pr-10">
      <v-card-title class="pb-4 pr-8">Журнал звонков с мобильных устройств</v-card-title>
      <v-spacer></v-spacer>
    </v-col>
    <v-col cols="12" sm="8" md="6" lg="4" class="pt-4">
      <v-autocomplete
        :items="doorphones"
        v-model="doorphone"
        item-value="key"
        item-text="address"
        placeholder="Выберите домофон"
        outlined
        dense
        hide-details
        class="shrink ma-2 pr-4"
        return-object
        v-on:change="OpenJurnal()"
      />
    </v-col>
  </v-row>
  <v-data-table
    class="table"
    :headers="headersCallLog"
    :items="callLogs"
  >
    <template v-slot:item.createdAt="{item}">
      {{ ruDateFormat(new Date(new Date(item.created_at).setHours(new Date(item.created_at).getHours() + 4))) }}
    </template>
    <template v-slot:item.snapshot_path="{ item }">
      <v-img
        v-if="item.snapshot_path"
        :src="`${item.snapshot_path}`"
        max-width="200"
        class="ml-auto mr-auto my-2"
        style="cursor: pointer"
        @click="zoomPhoto(item)"
      ></v-img>
    </template>
  </v-data-table>
    <v-dialog v-model="showZoomPhoto" :max-width="isMobile ? '90%' : '50%'" @input="closeZoomPhoto">
      <zoom-photo
        v-model="showZoomPhoto"
        :keyModal="`${keyModal.id}`"
        :photo="currentZoomPhoto"
        @closeZoomPhoto="closeZoomPhoto()"
      >
      </zoom-photo>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import zoomPhoto from './zoomPhoto';
import { headersCallLog } from '../consts';

export default {
  name: 'CallLogClient',
  mixins: [ruDateFormatMixin],
  props: ['id'],
  components: { zoomPhoto },
  data () {
    return {
      headersCallLog,
      include: ['client,doorphone'],
      limit: 200,
      callLogs: [],
      doorphone: {},
      doorphones: [],
      doorphoneId: null,
      currentImage: null,
      showZoomPhoto: false,
      currentZoomPhoto: '',
      keyModal: '',
      dialogImage: false,
      isMobile: false,
      loading: false,
    };
  },
  created () {
    this.doorphones = this.client.abonents.flatMap(abonent =>
      abonent.doorphones.map((doorphone, index) => ({
        value: doorphone.id,
        address: this.getDoorphoneAddress(doorphone),
        doorphone: doorphone,
        apartment_id: abonent.apartment,
        key: abonent.id,
      })),
    );

    if (this.doorphones.length > 0) {
      this.doorphone = this.doorphones[0];
    }
    this.OpenJurnal();
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
  },
  computed: {
    ...mapGetters({
      client: 'Client/client',
    }),
  },
  methods: {
    ...mapActions({
      getCallLogClient: 'CallLog/getCallLogClient',
    }),
    zoomPhoto (photo) {
      this.currentZoomPhoto = photo.snapshot_path;
      this.keyModal = photo.id;
      this.showZoomPhoto = true;
    },
    closeZoomPhoto () {
      this.showZoomPhoto = false;
      this.currentZoomPhoto = null;
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.type === 'G') {
        address += ' (калитка)';
      }
      if (doorphone.type === 'A') {
        address += ' (доп.вход)';
      }
      return address;
    },
    OpenJurnal () {
      const options = {
        include: this.include,
        filters: { apartment: this.doorphone.apartment_id },
        limit: this.limit,
      };
      this.loading = true;
      this.getCallLogClient({
        options,
        id: this.doorphone.value,
      })
        .then((result) => {
          this.callLogs = result.data;
          this.callLogs.forEach(callLog => {
            callLog.loading = true;
          });
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке журнала звонков');
          }
        });
    },
  },
};
</script>
